import { render, staticRenderFns } from "./FormFileConfig.vue?vue&type=template&id=46193737&scoped=true"
import script from "./FormFileConfig.vue?vue&type=script&lang=js"
export * from "./FormFileConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46193737",
  null
  
)

export default component.exports